export const CLUSTER_NETWORK = 'clusterNetwork';
export const VPC = 'vpc';
